/* eslint-disable */
import bi1_data_validation from '../../base_i1_datavalidation'
import { RC, CR } from '../../base_i2_success_codes'
import base_i3_log from '../../base_i3_logging'
import { ajax } from 'noquery-ajax'

function getUserPermission(user_uid, firebase_email, firebase_token, org_uid, cicp_uid, is_guest=false) {
  return new Promise(function (resolve, reject) {
    const debug_data = [];
    const task_id = 'p1s6t9_getUserPermission';
    let return_msg = '';

    ///// input validation
    let call_result = bi1_data_validation.is_not_null(user_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_email_address(firebase_email);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(firebase_token);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(org_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cicp_uid);
    debug_data.push(call_result)
    call_result = bi1_data_validation.is_bool(is_guest);
    debug_data.push(call_result)

    let validation_failed_flag = false;
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed_flag = true;
        break;
      }
    }

    if (validation_failed_flag === true) {
      return_msg += 'input validation failed';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      reject({ success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data });
      return;
    }
    /////</end> input validation

    ajax({
        url: `${window.G_p1s6_tasks_domain}/p1s6t9-get-user-permission`,
        method: 'POST',
        dataType: 'JSON',
  
        data: {
            'user_uid': user_uid,
            'firebase_email': firebase_email,
            'firebase_token': firebase_token,
            'p1s6t9-org_uid': org_uid,
            'p1s6t9-cicp_uid': cicp_uid,
            'p1s6t9-is_guest': is_guest
        },
        
        success: function (result) {
          resolve({ success: RC.success, return_msg: return_msg, debug_data: debug_data, json_response: result});
        },
        error: function (result) {
          console.log(result)
          if (result.status === 401) {
            window.G_firebase_auth.bi5forceTokenRefresh();
          }
          return_msg += 'failed to get user permission, error data: ' + JSON.stringify(result);
          base_i3_log(G_username, G_ip, G_page_id, task_id, RC.ajax_failure, return_msg, debug_data);
          reject({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data});
        }
      })
  });
};

export default getUserPermission




// WEBPACK FOOTER //
// ./src/watchdog_includes/json_tasks/p1s6/p1s6t9.js